module.exports = __webpack_public_path__ + "img/314.19091cc7.svg";